import moment from "moment";

/**
 * Merges product changes
 * @param {Object} prodInStore
 * @param {Object} products
 * @return {*}
 */
export function findStoreProduct(prodInStore, products) {
    const updatedProduct = products.find(p => p.productId === prodInStore.product.productId && p.chainId === prodInStore.product.chainId);
    let priceObj = {};
    let adminObj = {};
    if( updatedProduct ){
        priceObj = updatedProduct.futureEndPriceDate && updatedProduct.futureEndPrice ? ( 
            moment().isSame(moment(updatedProduct.futureEndPriceDate), "date") ? {
                //the new price will be set now
                currentEndCusPrice: parseFloat(updatedProduct.futureEndPrice),
                futureEndPrice: null,
                futureEndPriceDate: null,
            } : {
                //the new price will be set in the future
                currentEndCusPrice: updatedProduct.currentEndCusPrice ? parseFloat(updatedProduct.currentEndCusPrice) : prodInStore.product.currentEndCusPrice,
                futureEndPrice: updatedProduct.futureEndPrice ? parseFloat(updatedProduct.futureEndPrice) : prodInStore.product.futureEndPrice,
                futureEndPriceDate: updatedProduct.futureEndPriceDate ? updatedProduct.futureEndPriceDate : prodInStore.product.futureEndPriceDate,
            }
        ) : {
            currentEndCusPrice: parseFloat(updatedProduct.currentEndCusPrice),
            futureEndPrice: null,
            futureEndPriceDate: null,
        };
        adminObj = updatedProduct.futureAdminChargeDate && updatedProduct.futureAdminCharge ? ( 
            moment().isSame(moment(updatedProduct.futureAdminChargeDate), "date") ? {
                //the new charge will be set now
                adminChargePercent: parseFloat(updatedProduct.futureAdminCharge),
                futureAdminCharge: null,
                futureAdminChargeDate: null,
            } : {
                //the new charge will be set in the future
                adminChargePercent: updatedProduct.adminChargePercent ? parseFloat(updatedProduct.adminChargePercent) : prodInStore.product.adminChargePercent,
                futureAdminCharge: updatedProduct.futureAdminCharge ? parseFloat(updatedProduct.futureAdminCharge) : prodInStore.product.futureAdminCharge,
                futureAdminChargeDate: updatedProduct.futureAdminChargeDate ? updatedProduct.futureAdminChargeDate : prodInStore.product.futureAdminChargeDate,
            }
        ) : {
            adminChargePercent: parseFloat(updatedProduct.currentEndCusPrice),
            futureAdminCharge: null,
            futureAdminChargeDate: null,
        };
    }
    const result =
        updatedProduct !== undefined
            ? {
                ...prodInStore,
                product: {
                    ...prodInStore.product,
                    invoiceGroupId: updatedProduct.invoiceGroupId,
                    invoiceGroupName: updatedProduct.invoiceGroupName ? updatedProduct.invoiceGroupName : prodInStore.product.invoiceGroupName,
                    isAvailable: updatedProduct.isAvailable,
                    inCatalogue: updatedProduct.inCatalogue,
                    //
                    ...priceObj,
                    ...adminObj,
                }
            }
            : prodInStore;
    return result;
}